export class UTMUtilities {
  /**
   * Returns the correct UTM zone for this lat/long.
   * Norway and the Svalbard area contain exceptions to the otherwise uniform distribution of UTM zone boundaries.
   * 32V is extended into the north sea, at the expense of 31V.
   * For Svalbard, multiple zones have been expanded.
   * @private
   */
  static getUTMZone(latitude: number, longitude: number): number {
    const normalizedLongitude = (((longitude % 360) + 540) % 360) - 180;
    let zone: number = Math.floor((180 + normalizedLongitude) / 6) + 1;
    const inNorway32 = latitude >= 56 && latitude < 64 && normalizedLongitude >= 3 && normalizedLongitude < 12;
    const inSvalbardException = latitude >= 72 && latitude < 84;
    if (inNorway32) {
      zone = 32;
    }
    else if (inSvalbardException) {
      if (normalizedLongitude >= 0 && normalizedLongitude < 9) {
        zone = 31;
      }
      else if (normalizedLongitude >= 9 && normalizedLongitude < 21) {
        zone = 33;
      }
      else if (normalizedLongitude >= 21 && normalizedLongitude < 33) {
        zone = 35;
      }
      else if (normalizedLongitude >= 33 && normalizedLongitude < 42) {
        zone = 37;
      }
    }
    return zone;
  }

  /**
   * Gets the UTM letter designator for UTM coordinate representations.
   * @param lat
   * @private
   */
  static getUTMLetterDesignator(lat: number): string {
    // Basic implementation for latitudes -80 to 84
    if (lat < -80 || lat > 84) {
      return 'Z';
    }
    const bands = 'CDEFGHJKLMNPQRSTUVWX';
    const bandIdx = Math.floor((lat + 80) / 8);
    return bands[Math.max(0, Math.min(bandIdx, bands.length - 1))];
  }

  /**
   * Returns the correct EPSG code for the given UTM zone and latitude. EPSG codes for UTM zones in the northern hemisphere start at 32600, while those in the southern hemisphere start at 32700.
   * @param zone
   * @param latitude
   */
  static getEPSGCode(zone: number, latitude: number): number {
    return (latitude >= 0 ? 32600 : 32700) + zone;
  }
}
